// ILF Product Slider — behaviour for sections/ilf-product-slider.liquid.
//
// <ilf-product-slider> owns one Swiper instance built from its data
// attributes. Swiper (vendored swiper-bundle.min.js) is loaded by the
// section itself; the element waits for the window load event if the
// library has not executed yet. Theme Editor re-renders are covered by
// connectedCallback / disconnectedCallback — no shopify:* listeners needed.

class IlfProductSlider extends HTMLElement {
  connectedCallback() {
    if (this.initialised) return;
    this.initialised = true;

    this.container = this.querySelector('.swiper-container');
    if (!this.container) return;

    if (window.Swiper) {
      this.initSwiper();
    } else {
      this.onWindowLoad = this.initSwiper.bind(this);
      window.addEventListener('load', this.onWindowLoad, { once: true });
    }
  }

  disconnectedCallback() {
    if (this.onWindowLoad) window.removeEventListener('load', this.onWindowLoad);
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  initSwiper() {
    if (!window.Swiper) {
      console.error('ilf-product-slider: Swiper library is not loaded.');
      return;
    }
    if (this.container.swiper) this.container.swiper.destroy(true, true);

    const data = this.dataset;
    const slidesPerViewMobile = parseFloat(data.slidesPerViewMobile || '1');
    const slidesPerViewTablet = parseFloat(data.slidesPerViewTablet || '2');
    const slidesPerViewDesktop = parseFloat(data.slidesPerViewDesktop || '4');
    const slideSpacing = parseInt(data.slideSpacing || '0', 10);
    const tabletBreakpoint = parseInt(data.tabletBreakpoint || '750', 10);
    const autoplayDelay = parseInt(data.autoplayDelay || '0', 10);
    const slideCount = this.container.querySelectorAll('.swiper-slide').length;

    // 'page' (default): arrows, swipe and autoplay advance a whole page of
    // cards and each pagination dot represents one page. 'single': the
    // classic one-slide advance with a dot per scroll position.
    const advanceByPage = data.slideAdvance !== 'single';
    const groupFor = (slidesPerView) => (advanceByPage ? Math.max(1, Math.floor(slidesPerView)) : 1);

    this.swiper = new window.Swiper(this.container, {
      loop: data.loopSlider === 'true',
      slidesPerView: slidesPerViewMobile,
      slidesPerGroup: groupFor(slidesPerViewMobile),
      spaceBetween: slideSpacing,
      watchOverflow: true,
      runCallbacksOnInit: false,
      autoplay:
        autoplayDelay > 0
          ? {
              delay: autoplayDelay * 1000,
              disableOnInteraction: data.disableOnInteraction === 'true',
              pauseOnMouseEnter: true,
            }
          : false,
      pagination:
        data.showPagination === 'true' && slideCount > slidesPerViewMobile
          ? {
              el: this.querySelector('.ilf-slider-pagination'),
              clickable: true,
            }
          : false,
      navigation:
        data.showNavigation === 'true'
          ? {
              nextEl: this.querySelector('.ilf-slider-next'),
              prevEl: this.querySelector('.ilf-slider-prev'),
            }
          : false,
      breakpoints: {
        [tabletBreakpoint]: {
          slidesPerView: slidesPerViewTablet,
          slidesPerGroup: groupFor(slidesPerViewTablet),
          spaceBetween: slideSpacing,
        },
        990: {
          slidesPerView: slidesPerViewDesktop,
          slidesPerGroup: groupFor(slidesPerViewDesktop),
          spaceBetween: slideSpacing,
        },
      },
    });
  }
}

if (!customElements.get('ilf-product-slider')) {
  customElements.define('ilf-product-slider', IlfProductSlider);
}
